import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';

export default function Header() {
  const [searchQuery, setSearchQuery] = useState('');
  const [showCategories, setShowCategories] = useState(false);
  const [showUserMenu, setShowUserMenu] = useState(false);
  const navigate = useNavigate();

  const handleSearch = (e) => {
    e.preventDefault();
    if (searchQuery.trim()) {
      navigate(`/courses?search=${encodeURIComponent(searchQuery)}`);
    }
  };

  const categories = [
    'Development',
    'Business',
    'Design',
    'Marketing',
    'IT & Software',
    'Personal Development',
    'Photography',
    'Music',
  ];

  return (
    <header className="bg-white border-b border-gray-200 sticky top-0 z-50">
      <div className="px-6 py-3">
        <div className="flex items-center justify-between gap-6">
          <Link to="/" className="flex items-center gap-2 flex-shrink-0">
            <div className="text-2xl font-bold text-purple-600">
              E-Learning
            </div>
          </Link>

          <div className="relative flex-shrink-0">
            <button
              onClick={() => setShowCategories(!showCategories)}
              className="px-4 py-2 text-sm font-medium text-gray-700 hover:text-purple-600 flex items-center gap-1 whitespace-nowrap cursor-pointer"
            >
              Categories
              <i className={`ri-arrow-down-s-line text-lg transition-transform ${showCategories ? 'rotate-180' : ''}`}></i>
            </button>
            {showCategories && (
              <div className="absolute top-full left-0 mt-2 w-64 bg-white border border-gray-200 rounded-lg shadow-lg py-2">
                {categories.map((category) => (
                  <Link
                    key={category}
                    to={`/courses?category=${encodeURIComponent(category)}`}
                    className="block px-4 py-2 text-sm text-gray-700 hover:bg-purple-50 hover:text-purple-600 cursor-pointer"
                    onClick={() => setShowCategories(false)}
                  >
                    {category}
                  </Link>
                ))}
              </div>
            )}
          </div>

          <form onSubmit={handleSearch} className="flex-1 max-w-2xl">
            <div className="relative">
              <input
                type="text"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                placeholder="Search for anything"
                className="w-full px-4 py-2.5 pl-12 text-sm border border-gray-300 rounded-full focus:outline-none focus:border-purple-600 focus:ring-2 focus:ring-purple-100"
              />
              <i className="ri-search-line absolute left-4 top-1/2 -translate-y-1/2 text-gray-400 text-lg"></i>
            </div>
          </form>

          <nav className="flex items-center gap-4 flex-shrink-0">
            <Link
              to="/instructor"
              className="text-sm font-medium text-gray-700 hover:text-purple-600 whitespace-nowrap cursor-pointer"
            >
              Teach on LearnHub
            </Link>
            <Link
              to="/my-learning"
              className="text-sm font-medium text-gray-700 hover:text-purple-600 whitespace-nowrap cursor-pointer"
            >
              My Learning
            </Link>
            <Link to="/cart" className="relative cursor-pointer">
              <i className="ri-shopping-cart-line text-2xl text-gray-700 hover:text-purple-600"></i>
              <span className="absolute -top-1 -right-1 bg-purple-600 text-white text-xs w-5 h-5 rounded-full flex items-center justify-center">
                3
              </span>
            </Link>
            <div className="relative">
              <button
                onClick={() => setShowUserMenu(!showUserMenu)}
                className="w-10 h-10 rounded-full bg-purple-600 text-white flex items-center justify-center font-medium cursor-pointer"
              >
                JD
              </button>
              {showUserMenu && (
                <div className="absolute top-full right-0 mt-2 w-56 bg-white border border-gray-200 rounded-lg shadow-lg py-2">
                  <div className="px-4 py-3 border-b border-gray-200">
                    <div className="font-medium text-gray-900">John Doe</div>
                    <div className="text-sm text-gray-500">john.doe@example.com</div>
                  </div>
                  <Link
                    to="/my-learning"
                    className="block px-4 py-2 text-sm text-gray-700 hover:bg-purple-50 cursor-pointer"
                  >
                    My Learning
                  </Link>
                  <Link
                    to="/cart"
                    className="block px-4 py-2 text-sm text-gray-700 hover:bg-purple-50 cursor-pointer"
                  >
                    My Cart
                  </Link>
                  <Link
                    to="/instructor"
                    className="block px-4 py-2 text-sm text-gray-700 hover:bg-purple-50 cursor-pointer"
                  >
                    Instructor Dashboard
                  </Link>
                  <div className="border-t border-gray-200 mt-2 pt-2">
                    <button className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-purple-50 cursor-pointer">
                      Account Settings
                    </button>
                    <button className="block w-full text-left px-4 py-2 text-sm text-red-600 hover:bg-red-50 cursor-pointer">
                      Log Out
                    </button>
                  </div>
                </div>
              )}
            </div>
          </nav>
        </div>
      </div>
    </header>
  );
}
